import React from "react";
import {Panel, FormControl, Col} from "react-bootstrap";
import AscModal from "../Elements/Modal/Modal";
import ASFieldGroup from "../Elements/FieldGroup/FieldGroup";
import AscComponent from "../../components/AscComponent";

export default class CallHistoryAnalysisSettingModal extends AscComponent {
    constructor(props) {
        super(props);

        this.state = {
            company_name: this.props.company_name
        };
    }

    dataSetting = (select, id) => {
        let name = select.find(row => row.value === id);
        return name ? name.label : null;
    }

    validationHandle = () => {
        return true;
    }

    render() {
        const {
            state,
            propSetState,
            langText,
            propsState,
            onSave
        } = this.props;

        const { data } = propsState;

        return (
            <AscModal
                key="call-history-analysis-setting-check-modal"
                state={state}
                propSetState={propSetState}
                langText={langText}
                validationHandle={this.validationHandle}
                customFunc={async () => {
                    if (window.confirm(this.props.langText.Message.CallHistoryAnalysisSettingConfirm)) {
                        // 親コンポーネントの保存処理を呼び出す
                        if (onSave) {
                            await onSave();
                        }
                    }
                }}>
                <Panel bsStyle="info">
                    <Panel.Heading>
                        <Panel.Title>
                            {langText.Body.SettingCallHistoryAnalysis}
                        </Panel.Title>
                    </Panel.Heading>

                    <Panel.Body>
                        <div>
                            <p className="preview_add">
                                {langText.Message.Preview_update}
                            </p>
                            <p>
                                {langText.Message.Preview_update_message1}
                            </p>
                            <p className="preview_message">
                                {langText.Message.Preview_update_message2}
                            </p>
                            <p className="preview_message">
                                {langText.Message.Preview_update_message3}
                            </p>
                            <hr color="#999"/>
                        </div>

                        <Col sm={12}>
                            <ASFieldGroup
                                key="company_name"
                                label={langText.Body.CompanyName}>
                                <FormControl.Static>{this.props.state.company_name}</FormControl.Static>
                            </ASFieldGroup>
                            <ASFieldGroup
                                key="score_range"
                                label={langText.Body.SettingCallHistoryAnalysisRange}>
                                <FormControl.Static>
                                    {langText.Body.SettingCallHistoryAnalysisMinScore}：{data.score_min}　
                                    {langText.Body.SettingCallHistoryAnalysisMaxScore}：{data.score_max}
                                </FormControl.Static>
                            </ASFieldGroup>
                            <ASFieldGroup
                                key="score_base"
                                label={langText.Body.SettingCallHistoryAnalysisDefaultScore}>
                                <FormControl.Static>{data.score_base}</FormControl.Static>
                            </ASFieldGroup>
                            <ASFieldGroup
                                key="talk_time_scores"
                                label={langText.Body.SettingCallHistoryAnalysisTalkTimeScore}>
                                <FormControl.Static>
                                    <div>
                                        <div className="multi_delete_extension flex-style">
                                            <span style={{minWidth: '150px', display: 'inline-block'}}>{langText.Body.SettingCallHistoryAnalysisTalkTimeScore1min}:</span>
                                            <span>{data.score_talk_minutes_less_than_1}</span>
                                        </div>
                                        <div className="multi_delete_extension flex-style">
                                            <span style={{minWidth: '150px', display: 'inline-block'}}>{langText.Body.SettingCallHistoryAnalysisTalkTimeScore1to3min}:</span>
                                            <span>{data.score_talk_minutes_1_to_3}</span>
                                        </div>
                                        <div className="multi_delete_extension flex-style">
                                            <span style={{minWidth: '150px', display: 'inline-block'}}>{langText.Body.SettingCallHistoryAnalysisTalkTimeScore3to5min}:</span>
                                            <span>{data.score_talk_minutes_3_to_5}</span>
                                        </div>
                                        <div className="multi_delete_extension flex-style">
                                            <span style={{minWidth: '150px', display: 'inline-block'}}>{langText.Body.SettingCallHistoryAnalysisTalkTimeScore5to10min}:</span>
                                            <span>{data.score_talk_minutes_5_to_10}</span>
                                        </div>
                                        <div className="multi_delete_extension flex-style">
                                            <span style={{minWidth: '150px', display: 'inline-block'}}>{langText.Body.SettingCallHistoryAnalysisTalkTimeScore10to20min}:</span>
                                            <span>{data.score_talk_minutes_10_to_20}</span>
                                        </div>
                                        <div className="multi_delete_extension flex-style">
                                            <span style={{minWidth: '150px', display: 'inline-block'}}>{langText.Body.SettingCallHistoryAnalysisTalkTimeScore20to30min}:</span>
                                            <span>{data.score_talk_minutes_20_to_30}</span>
                                        </div>
                                        <div className="multi_delete_extension flex-style">
                                            <span style={{minWidth: '150px', display: 'inline-block'}}>{langText.Body.SettingCallHistoryAnalysisTalkTimeScore30to40min}:</span>
                                            <span>{data.score_talk_minutes_30_to_40 !== undefined && data.score_talk_minutes_30_to_40 !== null ? data.score_talk_minutes_30_to_40 : ""}</span>
                                        </div>
                                        <div className="multi_delete_extension flex-style">
                                            <span style={{minWidth: '150px', display: 'inline-block'}}>{langText.Body.SettingCallHistoryAnalysisTalkTimeScore40to50min}:</span>
                                            <span>{data.score_talk_minutes_40_to_50}</span>
                                        </div>
                                        <div className="multi_delete_extension flex-style">
                                            <span style={{minWidth: '150px', display: 'inline-block'}}>{langText.Body.SettingCallHistoryAnalysisTalkTimeScore50to60min}:</span>
                                            <span>{data.score_talk_minutes_50_to_60}</span>
                                        </div>
                                        <div className="multi_delete_extension flex-style">
                                            <span style={{minWidth: '150px', display: 'inline-block'}}>{langText.Body.SettingCallHistoryAnalysisTalkTimeScore60min}:</span>
                                            <span>{data.score_talk_minutes_60_or_more}</span>
                                        </div>
                                    </div>
                                </FormControl.Static>
                            </ASFieldGroup>
                            
                            <ASFieldGroup
                                key="op_ratio_setting"
                                label={langText.Body.SettingCallHistoryAnalysisOpRatio}>
                                <FormControl.Static>
                                    <span style={{minWidth: '200px', display: 'inline-block'}}>{langText.Body.SettingCallHistoryAnalysisOpRatioTarget}：{data.goal_op_talk_per}%</span>
                                    <span>{langText.Body.SettingCallHistoryAnalysisOpRatioTargetScoreValue}：{data.minus_score_op_talk_per_every_1per_deviation}</span>
                                </FormControl.Static>
                            </ASFieldGroup>
                            
                            <ASFieldGroup
                                key="silence_setting"
                                label={langText.Body.SettingCallHistoryAnalysisNoSoundCount}>
                                <FormControl.Static>
                                    <span style={{minWidth: '200px', display: 'inline-block'}}>{langText.Body.SettingCallHistoryAnalysisNoSoundCountSecond}：{data.seconds_determine_silence}{this.props.langText.Body.Second}</span>
                                    <span>{langText.Body.SettingCallHistoryAnalysisNoSoundCountScoreValue}：{data.minus_score_silence}</span>
                                </FormControl.Static>
                            </ASFieldGroup>
                            
                            <ASFieldGroup
                                key="conflict_setting"
                                label={langText.Body.SettingCallHistoryAnalysisNoOverlapCount}>
                                <FormControl.Static>
                                    <span style={{minWidth: '200px', display: 'inline-block'}}>{langText.Body.SettingCallHistoryAnalysisNoOverlapCountSecond}：{data.seconds_determine_conflict}{this.props.langText.Body.Second}</span>
                                    <span>{langText.Body.SettingCallHistoryAnalysisNoOverlapCountScoreValue}：{data.minus_score_conflict}</span>
                                </FormControl.Static>
                            </ASFieldGroup>
                        </Col>
                    </Panel.Body>
                </Panel>
            </AscModal>
        );
    }
}